import React from "react";
import { Link } from "theme-ui";

export default function HomePage() {
  const shopid = "0000001";


  return (
    <div>
      <Link href={`/goods/list?shopid=${shopid}`}>상품 조회 페이지</Link>
    </div>
  );
}
